<template>
  <component
    :is="lazyErrorRuntime"
    :error="props.error"
  />
</template>

<script lang="ts" setup>
  import type { NuxtError } from 'nuxt/app'

  import { initIntercomScriptSpinarium } from '@/public/static-media-frontend/script-spinarium'

  const props = defineProps<{
    error: NuxtError<{
      isTwoFactor: boolean
    }>
  }>()

  const userStore = useBrickUserStore()
  const vipStore = useBrickVipStore()
  const rootStore = useBrickRootStore()
  const { locale } = useLocale()

  onMounted(() => {
    setTimeout(() => {
      initIntercomScriptSpinarium({ locale: locale.value, rootStore, userStore, vipStore })
    }, 4000)
  })

  const lazyErrorRuntime = computed(() => resolveComponent('LazySpinariumErrorRuntime'))
</script>
